import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";
import { XCircleIcon, CheckIcon } from "components/Icons";

const classes =
  "flex mt-auto mb-1 h-10 border border-neutral-400 shadow-md cursor-pointer rounded-lg overflow-hidden text-xl hover:opacity-90 disabled:opacity-50 justify-center active:scale-95";

function ButtonCheck({ name, readOnly, label, method, handleButton, data }) {
  let iconColor = "text-neutral-100 fill-current";
  let bgLeft = "bg-neutral-300";
  let textLeft = "text-neutral-700";
  let bgRight = "bg-neutral-500";
  if (data.value) {
    iconColor = "text-neutral-100";
    bgLeft = "bg-sky-800";
    textLeft = "text-white";
    bgRight = "bg-sky-500";
  }

  function handleClick(e) {
    e.preventDefault();
    data.value = !data.value;
    if (handleButton) {
      handleButton(name, method);
    }
  }

  const _size = "w-full";
  const style = "";

  const bgColor = "bg-white";
  // const _disabled = readOnly;
  return (
    <button
      type="button"
      onClick={(e) => handleClick(e)}
      className={cn(classes, style, _size, bgColor)}
      disabled={readOnly}
    >
      <div className={cn("flex w-4/5 h-full", bgLeft)}>
        <span className={cn("flex my-auto text-sm ml-4", textLeft)}>
          <FM id={label} />
        </span>
      </div>
      <div className={cn("flex w-1/5 h-full", bgRight)}>
        {!data.value ? (
          <XCircleIcon
            key={name}
            className={cn("flex text-2xl my-auto mx-auto", iconColor)}
          />
        ) : (
          <CheckIcon
            key={name}
            className={cn("flex text-2xl my-auto mx-auto", iconColor)}
          />
        )}
      </div>
    </button>
  );
}

export default ButtonCheck;
